export default {
    name: 'ExternalLinkSmall',
    dimensions: { width: 10, height: 10 },
    content: `
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.292893 9.70711C-0.0976315 9.31658 -0.0976315 8.68342 0.292893 8.29289L6.58579 2H3C2.44772 2 2 1.55228 2 1C2 0.447715 2.44772 0 3 0H9C9.55228 0 10 0.447715 10 1V7C10 7.55228 9.55228 8 9 8C8.44772 8 8 7.55228 8 7V3.41421L1.70711 9.70711C1.31658 10.0976 0.683417 10.0976 0.292893 9.70711Z" fill="currentColor"/>
    `
};
